import isEmpty_ from 'lodash/isEmpty';
import some_ from 'lodash/some';

import ypath from '../../common/thor/ypath';
import {isNullable} from '../../../shared/utils/toolkit/type/isNullable';

export function hasTaskHistograms(operation: unknown) {
    const progress = ypath.getValue(operation, '/@progress');
    const tasks = isNullable(progress) ? undefined : ypath.getValue(progress, '/tasks');
    return some_(tasks, ({estimated_input_data_weight_histogram, input_data_weight_histogram}) => {
        return (
            !isEmpty_(estimated_input_data_weight_histogram) ||
            !isEmpty_(input_data_weight_histogram)
        );
    });
}
